import styled from 'styled-components';

export const DraggableContent = styled.div`
  display: inline-block;
  user-select: none;
`;
